import Ellipsis from '@clearkit/icons/glyphs/Ellipsis';
import ExportIcon from '@clearkit/icons/glyphs/Export';
import { CKButton } from '@clearkit/react';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import Menu from '@material-ui/core/Menu';

import MenuItem from '~/components/RedesignedMenuItem';
import paths from '~/lib/paths';
import DestroyHandler from '~/pages/audiences/components/DestroyHandler';

import DeleteIcon from './Delete.svg';
import styles from './styles';

class AudiencesLayoutActionsMenu extends React.Component {
  state = {
    isMenuOpen: false,
  };

  anchor = React.createRef();

  openMenu = () => {
    this.setState({ isMenuOpen: true });
  };

  closeMenu = () => {
    this.setState({ isMenuOpen: false });
  };

  render() {
    const { audience, classes, viewer } = this.props;
    const { isMenuOpen } = this.state;

    const disabled = !audience;

    return (
      <div ref={this.anchor}>
        <CKButton disabled={disabled} onClick={this.openMenu}>
          <Ellipsis height={32} />
        </CKButton>

        {audience && (
          <Menu
            anchorEl={this.anchor.current}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            getContentAnchorEl={null}
            onClose={this.closeMenu}
            open={isMenuOpen}>
            {viewer?.canExportAudiences && (
              <MenuItem>
                <a
                  className={classes.link}
                  href={paths.audienceExport(audience.id)}
                  rel="noopener noreferrer"
                  target="_blank">
                  <ListItemIcon>
                    <ExportIcon />
                  </ListItemIcon>{' '}
                  Export audience (admin only)
                </a>
              </MenuItem>
            )}

            <DestroyHandler audience={audience}>
              <MenuItem variant="destructive">
                <ListItemIcon>
                  <DeleteIcon />
                </ListItemIcon>
                Delete audience
              </MenuItem>
            </DestroyHandler>
          </Menu>
        )}
      </div>
    );
  }
}

AudiencesLayoutActionsMenu.propTypes = {
  audience: PropTypes.object,
  classes: PropTypes.object.isRequired,
  viewer: PropTypes.object,
};

export default withStyles(styles)(AudiencesLayoutActionsMenu);
